import * as React from "react";
import type { SVGProps } from "react";

const FacilityTrain = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3329 2.51299C11.5553 1.38499 8.44731 1.38499 5.66977 2.51299C4.75453 2.90982 4.16383 3.81388 4.16799 4.81144V12.5003C4.16799 13.881 5.28728 15.0003 6.66799 15.0003H13.3347C14.7154 15.0003 15.8347 13.881 15.8347 12.5003V4.81144C15.8388 3.81388 15.2481 2.90982 14.3329 2.51299V2.51299Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5013 11.6667H6.66797"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 11.6667H12.5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8346 9.16667H4.16797"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8346 4.99967H4.16797"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.9987 17.5L13.332 15"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66667 15L5 17.5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6654 17.4997H8.33203"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityTrain.displayName = "FacilityTrain";

export default FacilityTrain;
